import { Button, Result } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { logger } from '@tools/ui-utils/logger.util';

const Error = ({ error }: { error: Error }) => {
  const { t } = useTranslation();

  return (
    <Result
      status="500"
      title={t('error') as string}
      subTitle={t('generalError') as string}
      extra={
        <Button type="primary" onClick={() => window.location.reload()}>
          {t('tryAgain') as string}
        </Button>
      }
    />
  );
};

type MyProps = {
  component?: React.FC<React.PropsWithChildren<{ error: Error }>>;
  children: React.ReactNode;
};
type MyState = { hasError: boolean; error?: Error };

class ErrorBoundary extends React.Component<MyProps, MyState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  override componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error
    });

    logger.error(error, { errorInfo });
  }

  getErrorComponent() {
    const Component = this.props.component || Error;
    return <Component error={this.state.error as Error} />;
  }

  override render() {
    if (this.state.hasError) {
      return this.getErrorComponent();
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
